import axios from "axios";
import Globais, { validateToken } from "../../components/Globais";

//função que verifica se determinada cotaUsuario tem periodosUsuarios. retorna false se não tiver e true se tiver

export async function verificarSeTemPeriodoUsuario(cotaUsuarioId: number) {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/periodousuario/0/${cotaUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        if (response.data.length > 0) {
          console.log("tem periodo");
          return true;
        } else {
          return false;
        }
      }
    } catch (e) {
      console.log(e);

      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}
export async function verificarSeTemPeriodoUsuarioDefinido(
  cotaUsuarioId: number | null | undefined
) {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/periodo-usuario/periodousuario/0/${cotaUsuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response) {
        const periodosDefinidos = await response.data.filter(
          (p: any, index: number) => {
            if (
              p.alugar === 1 ||
              p.trocar === 1 ||
              p.utilizar === 1 ||
              p.concluido === 1
            ) {
              return p;
            } else {
              return null;
            }
          }
        );

        if (periodosDefinidos.length !== 0) {
          return true;
        } else {
          return false;
        }
      }
    } catch (e) {
      console.log(e);

      return false;
    }
  } else {
    document.location.href = "/login";
    return false;
  }
}

export const verificarAnuncioPropriedade = async (
  cotaUsuarioId: number | null | undefined
) => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/anuncio-propriedade/venda/cotaUsuario/${cotaUsuarioId}`;

  if (Token) {
    try {
      const response = await axios.get(URL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: Token.AuthStr,
        },
      });
      if (Array.isArray(response.data) && response.data.length > 0) {
        const { active, dataInativacaoAnuncio } = response.data[0]; // Acesse o primeiro item do array
        // Converte dataInativacaoAnuncio para um objeto Date
        const inactivationDate = new Date(dataInativacaoAnuncio);

        if (
          active === 1 &&
          (inactivationDate > new Date() || isNaN(inactivationDate.getTime()))
        ) {
          return true;
        }
      }

      return false; // Retorna false se não passar nas verificações
    } catch (error) {
      console.error(error);
    }
  }
};
